import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { MapUserProvider } from "../contexts/MapUserContext";
import { AdminProvider } from "../contexts/AdminContext";
import { TenantProvider } from "../contexts/TenantContext";
import { DialogProvider } from "../contexts/DialogContext";

const MapUserComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <MapUserProvider key={0} />,
        <AdminProvider key={1} />,
        <TenantProvider key={2} />,
        <DialogProvider key={3} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export { MapUserComposer };
